module.exports = __webpack_public_path__ + "img/map_upper-deck-terrace.133a8eca.jpg";